<template>
	<v-navigation-drawer v-model="inputValue" :clipped="$vuetify.breakpoint.lgAndUp" app>
		<v-list dense>
			<template v-for="item in links">
				<v-list-item :key="item.text" link :to="item.to" v-if="checkVisibility(item.admin)">
					<v-list-item-action>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>{{ item.text }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</template>
		</v-list>
	</v-navigation-drawer>
</template>
<script>
export default {
	data: () => ({
		links: [
			{
				to: '/empresas',
				icon: 'location_city',
				text: 'Empresas',
				admin: false,
			},
			{
				to: '/usuarios',
				icon: 'lock',
				text: 'Usuários',
				admin: true,
			},
		],
	}),
	computed: {
		inputValue: {
			get() { return this.$store.state.drawer },
			set(val) { this.$store.commit('setDrawer', val) },
		},
	},
	methods: {
		checkVisibility(admin) {
			if (admin && this.$store.getters.userAdmin) return true
			return !admin
		},
	},
}
</script>
